import {TEAMS_API_URL} from 'app/urls';
import {UNLIMITED_PAGE_SIZE} from 'app/utils/constants';
import {get} from 'app/utils/request';

import type {ListResponseType, TeamSerializedType} from 'sweet-types';

export const requestTeams = (
  args: any
): Promise<ListResponseType<TeamSerializedType>> =>
  get<ListResponseType<TeamSerializedType>>(TEAMS_API_URL, {
    page_size: UNLIMITED_PAGE_SIZE,
    ...args,
  });
